import { ICONS, Props } from '../model';

import cls from './styles.module.pcss';

export function Icon({ name }: Props) {
  const Component = ICONS[name];

  return (
    <Component className={cls.Icon} />
  );
}
